import { useState, useContext } from "react";
import { Eye, EyeOff } from 'lucide-react';
import styles from "./ResetPasswordForm.module.scss";
import PasswordStrengthIndicator from "../../utils/PasswordStrengthIndicator/PasswordStrengthIndicator";
import LoadingIndicator from "../../utils/LoadingIndicator/LoadingIndicator";

// Import des traductions 
import { LanguageContext } from '../../context/LanguageContext';
import translations from '../../utils/translations/ResetPasswordFormTranslations';

const ResetPasswordForm = ({ onSubmit, passwordLoading }) => {

  // Utilisation du contexte de langue global
  const { language } = useContext(LanguageContext);

  // Accès simplifié aux traductions
  const t = translations[language] || translations.fr;

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [touched, setTouched] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setErrorMessage(""); // reset

    if (password !== confirmPassword) {
      setErrorMessage(t.passwordsDontMatch);
      return;
    }

    if (password.length < 8) {
      setErrorMessage(t.passwordMinLength);
      return;
    }

    onSubmit(password);
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <form onSubmit={handleSubmit} className={styles.form}>
      <div className={styles.passwordInputContainer}>
        <input
          className={styles.input}
          type={showPassword ? "text" : "password"}
          autoComplete="new-password"
          id="password"
          name="password"
          placeholder={t.newPasswordPlaceholder}
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
            if (!touched) setTouched(true);
          }}
          required
        />
        <button
          type="button"
          onClick={togglePasswordVisibility}
          className={styles.togglePasswordButton}
          aria-label={showPassword ? t.hidePasswordAria : t.showPasswordAria}
        >
          {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
        </button>
      </div>

      {touched && <PasswordStrengthIndicator password={password} />}

      <div className={styles.inputGroup}>
        <input
          className={styles.input}
          type="password"
          autoComplete="new-password"
          placeholder={t.confirmPasswordPlaceholder}
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />
      </div>

      {confirmPassword && confirmPassword !== password && (
        <p className={styles.error}>{t.passwordsDontMatch}</p>
      )}

      {errorMessage && <p className={styles.error}>{errorMessage}</p>}

      <button type="submit" className={styles.button} disabled={passwordLoading}>
        {passwordLoading ? <LoadingIndicator /> : t.submit}
      </button>
    </form>
  );
};

export default ResetPasswordForm;
